
























































































































import { defineComponent, PropType } from '@nuxtjs/composition-api';
import ProductCartButton from '~/components/pages/Product/ProductCartButton.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import AppPrice from '~/components/partials/App/AppPrice.vue';
import AppRectButton from '~/components/partials/App/AppRectButton.vue';
import ContentReview from '~/components/partials/Content/ContentReview.vue';
import ProductLabel from '~/components/partials/Product/ProductLabel.vue';
import { useProductIntroduction } from '~/composables/contents/useProductIntroduction';
import { PRODUCT_CART_BUTTON } from '~/constants';
import { DynamicPartsProductIntroduction } from '~/types/modules/contents';

export default defineComponent({
  components: {
    AppPrice,
    AppImage,
    AppLink,
    AppRectButton,
    ContentReview,
    ProductCartButton,
    ProductLabel,
  },
  props: {
    item: {
      type: Object as PropType<DynamicPartsProductIntroduction>,
      required: true,
    },
    productCode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const {
      url,
      ecDetailResponse,
      productVariant,
      maker,
      productName,
      searchProduct,
      isShowNew,
      catchCopies,
      threeLineCatchCopies,
      review,
      productDetailUrl,
      getLotteryInfo,
    } = useProductIntroduction(props);

    return {
      url,
      ecDetailResponse,
      productVariant,
      maker,
      productName,
      searchProduct,
      isShowNew,
      catchCopies,
      threeLineCatchCopies,
      review,
      productDetailUrl,
      PRODUCT_CART_BUTTON,
      getLotteryInfo,
    };
  },
});
